<template>
  <div class="nf-tips-only el-alert--warning is-light" role="alert">
    <div class="content" v-html="title" />
  </div>
</template>

<script>
export default {
  name: 'NfTipsOnly',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.nf-tips-only {
  width: 100%;
  padding: 8px 0;
  border-radius: 4px;

  i {
    margin-left: 16px;
    margin-top: 1px;
    width: 20px;
  }

  .content {
    padding: 0 16px 0 8px;
    height: auto;
    line-height: 20px;
    min-height: 20px;
    font-size: 13px;
  }
}
</style>
